import { collabStateManager } from '@databases/collab-state-manager';
import { getMediaClient, type MediaClient } from '@databases/utils/media-client';
import { useMemo } from 'react';

export function useMediaClient(contentId: string | undefined): MediaClient | undefined {
  const collabManager = collabStateManager.getCollabManager(contentId ?? '');

  return useMemo(() => {
    if (collabManager) {
      return getMediaClient(collabManager);
    } else {
      return undefined;
    }
  }, [collabManager]);
}
